






























import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { cloneDeep } from 'lodash';
import BaseComponent from '@/components/base-component.vue';
import * as service from '@/services/session-data';
import { PERMISSIONS_KEYS } from '@/settings/consts/permissions';

@Component
export default class PermissionDebug extends BaseComponent {
  public openPermissionsModal: boolean = false;
  public userPermissions: string[] = [];
  public oldUserPermissions: string[] = [];
  public allPermissions: string[] = [];

  public beforeMount(): void {
    this.getAllPermissions();
    this.getUserPermissions();
  }

  public openModal(): void {
    this.openPermissionsModal = true;
  }

  public closeModal(): void {
    this.openPermissionsModal = false;
  }

  public save(): void {
    const closeAction = () => {
      setTimeout(() => {
        service.updateUserPermissionsFromLocal(this.userPermissions);
        window.location.reload();
      }, 100);
      this.$emit('close');
    };

    this.dialog.show(
      'error',
      'Salvar',
      'Ao salvar a página será recarregada!',
      'Cancelar',
      '',
      'Salvar',
      closeAction,
    );
  }

  public getAllPermissions(): void {
    for (const permissionKey in PERMISSIONS_KEYS) {
      if (!!PERMISSIONS_KEYS[permissionKey]) {
        this.allPermissions.push(PERMISSIONS_KEYS[permissionKey]);
      }
    }
  }

  public getUserPermissions(): void {
    this.userPermissions = service.getUserPermissionsFromLocal();
    this.oldUserPermissions = cloneDeep(this.userPermissions);
  }
}
